import Machines_D_0 from '../Machines_D/Machines_D_0'
import Machines_D_1 from '../Machines_D/Machines_D_1'
import Machines_D_2 from '../Machines_D/Machines_D_2'
import Options from '../Options'
import Products_A_1 from '../Products_A/Products_A_1'
import Products_B_0 from './Products_B_0'

export default function Products_B_1 (output = 60, machine = 0, options) {
  options = options || Options
  let factory
  switch (options.Producer) {
    case 3:
      if (machine > 0) {
        output = machine * (60 / 0.3)
      } else {
        machine = output / (60 / 0.3)
      }
      factory = Machines_D_2(machine.toFixed(1))
      break
    case 2:
      if (machine > 0) {
        output = machine * (60 / 0.5)
      } else {
        machine = output / (60 / 0.5)
      }
      factory = Machines_D_1(machine.toFixed(1))
      break
    case 1:
    default:
      if (machine > 0) {
        output = machine * (60 / 0.7)
      } else {
        machine = output / (60 / 0.7)
      }
      factory = Machines_D_0(machine.toFixed(1))
  }
  return {
    name: '磁线圈',
    icon: '/static/img/products/b1.png',
    machine: factory,
    children: [
      Products_B_0(output, 0, options),
      Products_A_1(output * 0.5, 0, options)
    ],
    output
  }
}



// WEBPACK FOOTER //
// ./src/components/Products_B/Products_B_1.js